const ChevronLeft = ({ scale = 1 }: { scale?: number }) => {
  return (
    <svg width={16 * scale} height={16 * scale} viewBox="0 0 16 16" fill="none">
      <path
        d="M6.75732 3.40762L11.3535 8.00381L6.75732 12.6"
        stroke="var(--svg-color, #000)"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronLeft;
